import type {ColSpec} from "../../../../components/table/MithraTableHeadColumns";

export const CURRENCY_COLUMNS: Array<ColSpec> = [
    {cls: '', txt: 'Source', minWidth: 240},
    {cls: '', txt: 'Destination', minWidth: 240},
    {cls: '', txt: 'Rate'},
    {cls: '', txt: 'Created'},
]
